import { Trans } from '@lingui/macro';
import { useState } from 'react';
import './style.scss';

const Radio = (props) => {
    const [active, setActive] = useState(props.value);

    const onClick = (val) => {
        setActive(val);
        props.onChange(val);
    }

    return (
        <div className={`radio ${props.disabled ? 'disabled': ''}`}>
            <h5><Trans id={props.heading} values={props.heading} /></h5>
            {props.children.map((child, i) => {
                const isDisbaled = child.props.disabled || false

                return (
                    <div 
                        className={`radio-option ${active === child.props.value ? 'active' : ''} ${isDisbaled ? 'disabled': ''}`} 
                        onClick={() => onClick(child.props.value)} 
                        key={i}
                    >
                        <div className="circle " />
                        <h6><Trans id={child.props.text} values={child.props.text} /></h6>
                    </div>
                )
            })}
        </div>
    )
}

export default Radio;

export const RadioOption = ({ value, text }) => {
    return;
}